import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";import graphql from 'babel-plugin-relay/macro'
import ms from 'ms'

import {useFragment} from 'react-relay'
import parabolLogo from 'static/images/brand/mark-color.svg'

import NotificationSubtitle from '~/components/NotificationSubtitle'
import useRefreshInterval from '~/hooks/useRefreshInterval'
import NotificationBody from './NotificationBody'
import NotificationMessage from './NotificationMessage'
import NotificationRow from './NotificationRow'









const NotificationTemplate = (props) => {
  const {avatar, message, notification: notificationRef, action, children} = props
  const notification = useFragment(
    graphql`
      fragment NotificationTemplate_notification on Notification {
        createdAt
        status
      }
    `,
    notificationRef
  )
  const {createdAt, status} = notification
  // keep the timestamp fresh
  useRefreshInterval(ms('1m'))
  return (
    _jsx(NotificationRow, { avatar: avatar || parabolLogo, isParabol: !avatar, status: status, children: 
      _jsxs(NotificationBody, { children: [
        _jsx(NotificationMessage, { children: message})
        , _jsx(NotificationSubtitle, { timestamp: createdAt, children: action})
        , children
      ]})
    })
  )
}

export default NotificationTemplate
